import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../helpers/lang';

export type IgnoredTasksType = {
  id: number;
  name: LangType;
  staff: LangType;
  overtime: number;
};

export const stringToColor = (str: string) => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;
  const saturation = 70;
  const lightness = 50;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export const generateColors = (numColors: number): string[] => {
  const colors = [];
  const saturation = 100; // высокая насыщенность для контрастных цветов
  const lightness = 40; // средняя яркость для контрастных цветов

  for (let i = 0; i < numColors; i++) {
    const hue = Math.floor((i * 360) / numColors); // равномерное распределение оттенков
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }

  return colors;
};

export const withBarSelection = (chartData: ReactApexChartProps): ReactApexChartProps => {
  const chartType = chartData.options?.chart?.type;

  if (chartType === 'bar' || chartType === 'line') {
    const defaultOptions = chartData.options || {};
    const defaultXaxis = defaultOptions.xaxis || {};
    const defaultChart = defaultOptions.chart || {};

    return {
      ...chartData,
      options: {
        ...defaultOptions,
        responsive: [
          ...(defaultOptions.responsive || []),
          {
            breakpoint: 768,
            options: {
              chart: {
                zoom: {
                  enabled: false,
                  allowMouseWheelZoom: false,
                },
              },
            },
          },
        ],
        xaxis: { ...defaultXaxis, tickPlacement: 'on' },
        chart: {
          ...defaultChart,
          zoom: { enabled: true, allowMouseWheelZoom: false },
          toolbar: {
            show: true,
            autoSelected: 'zoom',
            tools: {
              reset: true,
              zoom: true,
              pan: true,
              download: false,
              zoomin: false,
              zoomout: false,
            },
          },
        },
        tooltip: {
          ...defaultOptions.tooltip,
        },
      },
    };
  }
  return chartData;
};
